import React from 'react';
import './ProcessView.scss';
import { ChevronProcessDiagram } from '../../../AdminMarketplace/ChevronProcessDiagram/ChevronProcessDiagram';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import { ChevronDiagramEvent } from '../../../AdminMarketplace/ChevronProcessDiagram/models/ChevronDiagramEvent';
import { LinkedDataRequestProject } from '../../../../slices/marketplace/timeline/models/linked-data-request-project.model';

interface ProcessViewProps {
    timelineEvents: TimelineEvent[];
    dataRequestProjects?: LinkedDataRequestProject[];
    engagementStartDate: Date;
    onActionClick(item: ChevronDiagramEvent): void;
    isEventActionVisible: (eventId: string) => boolean;
}

const ProcessView = (props: ProcessViewProps) => {
    return (
        <div className="process-view">
            <ChevronProcessDiagram
                timelineEvents={props.timelineEvents}
                dataRequestProjects={props.dataRequestProjects}
                engagementStartDate={props.engagementStartDate}
                onActionClick={props.onActionClick}
                isEventActionVisible={props.isEventActionVisible}
            />
        </div>
    );
};

export default ProcessView;
